export enum actionTypes {
    UPDATE_TERMS_CONDITIONS = 'TERMS_CONDITIONS:UPDATE'
}
